import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    position: 'relative',
    flexDirection: 'row',
    fontFamily: 'Lato',
    paddingHorizontal: 20,
    paddingTop: 20,
    width: '100%',
    height: '100%',
  },
  leftColumn: {
    width: '50%',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    gap: 25,
  },
  imageColumnWrapper: {
    position: 'absolute',
    flexDirection: 'column',
    gap: 25,
  },
  imageClip: {
    width: 340,
    height: 400,
    overflow: 'hidden',
  },
  image: {
    width: 340,
    height: 400,
    objectFit: 'cover',
    borderRadius: 5,
  },
  rightColumn: {
    width: '50%',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingLeft: 30,
    paddingTop: 200,
    height: '100%',
  },
  eventImage: {
    height: 320,
    width: 380,
    objectFit: 'contain',
  },
  textWrapper: {
    width: '100%',
    height: '100%',
    paddingLeft: 40,
  },
  title: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 26,
    fontWeight: 400,
    textAlign: 'left',
    marginTop: 20,
    marginLeft: 20,
    width: '70%',
  },
  subtitle: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 20,
    fontWeight: 400,
    textAlign: 'left',
    marginTop: 30,
    marginLeft: 20,
    width: '70%',
  },
});
